import { render, staticRenderFns } from "./PrintableSavedAnchorPage.vue?vue&type=template&id=c8f91a96&scoped=true"
import script from "./PrintableSavedAnchorPage.vue?vue&type=script&lang=js"
export * from "./PrintableSavedAnchorPage.vue?vue&type=script&lang=js"
import style0 from "./PrintableSavedAnchorPage.vue?vue&type=style&index=0&id=c8f91a96&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f91a96",
  null
  
)

export default component.exports